import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { aiVisibilityService } from '../../../services/aiVisibilityService';
import { FULL_REPORT_PRICE } from '../../../config/pricing';
import { PAYMENTS_LIVE } from '../../../config/payments';

// While payments run on Stripe test keys, say so and give the test card:
// nobody should type a real one.
const TEST_MODE = !PAYMENTS_LIVE;

// Pays for the full report of the free check just shown: opens Stripe's
// payment page, which sends the customer back to /pago/ok. `children` sit
// next to the button (e.g. the link to the example report); `contactHref`
// is offered if the payment page can't be opened.
const PayButton = ({ checkId, website, contactHref, children }) => {
  const [state, setState] = useState({ loading: false, error: null });

  const handlePay = async () => {
    setState({ loading: true, error: null });
    const result = await aiVisibilityService.startCheckout({ checkId, website: website || undefined });
    if (result.success && result.url) {
      window.location.assign(result.url);
      return; // stays "loading" while the browser leaves
    }
    setState({ loading: false, error: result.message });
  };

  return (
    <div>
      <div className="flex flex-wrap items-center gap-x-8 gap-y-5">
        <button type="button" className="lp-btn" onClick={handlePay} disabled={state.loading || !checkId}>
          {state.loading ? 'Abriendo el pago…' : `Ver mi informe completo · ${FULL_REPORT_PRICE}`}
          {!state.loading && <ArrowRight size={20} strokeWidth={2.6} aria-hidden="true" />}
        </button>
        {children}
      </div>

      <p className="mt-5 max-w-xl text-sm leading-relaxed text-[var(--lp-muted)]">
        Pago único, sin suscripción. Al pagar aceptas las{' '}
        <Link to="/legal/condiciones" className="underline underline-offset-4 hover:text-[var(--lp-text)]">
          condiciones de venta
        </Link>{' '}
        y la{' '}
        <Link to="/legal/privacidad" className="underline underline-offset-4 hover:text-[var(--lp-text)]">
          política de privacidad
        </Link>
        .
      </p>

      {TEST_MODE && (
        <p className="mt-2 max-w-xl text-sm leading-relaxed text-[var(--lp-muted)]">
          Pagos en modo de prueba: no se cobra nada. Usa la tarjeta{' '}
          <span className="lp-mono whitespace-nowrap text-[var(--lp-text)]">4242 4242 4242 4242</span>, cualquier
          fecha futura y cualquier CVC.
        </p>
      )}

      {state.error && (
        <p role="alert" className="mt-4 text-sm font-medium text-[var(--lp-alarm)]">
          {state.error}
          {contactHref && (
            <>
              {' '}
              <a href={contactHref} className="underline underline-offset-4">
                Escríbenos
              </a>{' '}
              y te lo preparamos.
            </>
          )}
        </p>
      )}
    </div>
  );
};

export default PayButton;
